<template>
  <div class="top-most" @click="hideModal">
    <div>
      <div id="onboarding" >
         <div
          id="onboarding-form" class=" col-sm-12 col-md-6"
          :class="{ 'swap-box1': toggle }"
        >
          <div class="onboarding-form-container">
            <!-- <div class="title-div"> -->
              <div class="main-title">
                <h1 class="font-weight-bold">Welcome to ALAT FAITH!</h1>
              </div>
              <div class="sub-title">
                <!-- <p>Tell us about you and your church</p> -->
              </div>
              <Toast />
            <!-- </div> -->

            <form style="width: 100%" @submit.prevent="saveForm">
              <!-- <div class="input-div">
                <label class="mb-0"></label>
                <div class="name-input">
                  <input
                    type="text"
                    class="input"
                    v-model="userDetails.firstName"
                    placeholder="First name"
                    required
                  />
                  <input
                    type="text"
                    class="input"
                    v-model="userDetails.lastName"
                    placeholder="Last name"
                  />
                </div>
              </div> -->

              <div class="input-div row">
                <div class="col-md-6">
                  <label class="mb-0 font-weight-bold small">WEMA Account Number<span style="color: red"> *</span> </label>
                  <input
                  v-model="accountNumber"
                  @blur="resolveCustomerDetail"
                  type="text"
                  class="input input-color"
                  placeholder=""
                  required
                />
                </div>
                <div class="col-md-6">
                  <label class="mb-0 font-weight-bold small ">Church Name <span style="color: red"> *</span> </label>
                  <input
                    v-model="maskChurchName"
                    type="text"
                    class="input input-color"
                    placeholder=""
                    required
                    disabled
                  />
                  <span class="align-self-end" v-if="loading">
                    <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status">
                    <span class="sr-only">Loading...</span>
                    </div>
                  </span>
                  <!-- <div class="mt-1">
                    <em class="mt-1 ">This will automatically come up, kindly confirm before clicking on save.</em>
                  </div> -->
                </div>
              </div>
              <div class="input-div row">
                <div class="col-md-6">
                  <label class="mb-0 font-weight-bold small">Email <span style="color: red"> *</span> </label>
                  <input
                  v-model="maxEmail"
                  type="text"
                  class="input input-color"
                  placeholder=""
                  required
                  :disabled="checking"
                />
                <div class="text-danger">{{ errorMessage }}</div>
                </div>
                <div class="col-md-6 mt-0">
                  <label class="mb-0 font-weight-bold small ">Phone Number</label>
                  <div class="w-100 mt-1">
                    <vue-tel-input
                    :value="maskPhoneNumber"
                    @input="onInput"
                    mode="international"
                    style="height: 40px"
                    @blur="invalidResponse"
                    :disabled="checking"
                  ></vue-tel-input>
                  </div>
                  <!-- <input
                        v-model.trim="phoneNumber"
                        type="text"
                        class="input phone-num input-color form-control"
                        :class="{ 'is-invalid' : !isValid, 'is-valid' : valid }"
                        placeholder=""
                        @blur="invalidResponse"
                        required
                      />
                      <div class="invalid-feedback">
                        Please provide a valid phone number.
                      </div> -->
                  <!-- <div class="row">
                    <div style=" cursor: pointer; " class=" col-md-4 mt-1 d-flex m-0 p-0 " @click="toggleCode">
                      <div class=" form-control py-2">
                         <div style="" class="codeModal d-flex w-100  ">
                          <span class="codeModal"><img :src="selectedCountry.flagUrl" class="codeModal" style="">
                          </span>
                          <span  class="codeModal">{{ selectedCountry.phoneCode ? selectedCountry.phoneCode.includes('+') ? selectedCountry.phoneCode : `+${selectedCountry.phoneCode}` : "" }}
                          </span>
                          <i class="pi pi-angle-down" style=""></i>
  
                        </div>
                      </div>
                       
                    </div>
                    <div class="col-md-8">
                      <input
                        v-model.trim="userDetails.phoneNumber"
                        type="text"
                        class="input phone-num input-color form-control"
                        :class="{ 'is-invalid' : !isValid, 'is-valid' : valid }"
                        placeholder=""
                        @blur="invalidResponse"
                        required
                      />
                      <div class="invalid-feedback">
                        Please provide a valid phone number.
                      </div>
                    </div>
                   
                  </div> -->
                  <!-- <div :class=" { 'flagCode' : showCode, 'hide-code' : !showCode } " class="codeModal">
                    <input class="codeInput input codeModal" v-model="searchText">
                    <div v-for="country in countryCodes" :key="country.id" class="codeModal" >
                      <div class="codeModal c-pointer" @click="selectCode(country)">
                        <span style="display: inline-block"><img :src="country.flagUrl"  style="width: 30px;height: 30px; margin: 10px; border-radius: 5px;"></span>
                        <span style="font-weight:700">{{ country.name }}</span> &nbsp;
                        <span style="display: inline-block; color: #6b6b6b;">{{ country.phoneCode ? country.phoneCode.includes('+') ? `(${country.phoneCode})` : `(+${country.phoneCode})`: "" }}</span>
                      </div>
                    </div>
                  </div>
                   -->
                </div>
              </div>
              <div class="input-div row">
                <div class="col-md-12">
                  <label class="mb-0 font-weight-bold small ">Password <span style="color: red"> *</span> </label>
                  <input
                    :type="passwordType"
                    v-model="password"
                    class="input"
                    placeholder="Password"
                    @blur="invalidResponse"
                    pattern=".{6,}"
                    required
                  />
                </div>
                 <div class="password-help col-md-12">
                  <span class="password-tip"
                    >At least 6 characters, but longer is better.</span
                  >
                  <span class="show-password"
                    ><a href="" class="show-password-link" @click="showPassword">{{
                      showBtnText
                    }}</a></span
                  >
                </div>
              </div>
              
              <!-- <div class="row ">
                <div class="col-md-12 mt-3 d-flex justify-content-center ">
                  <div class="col-md-12  "><hr class="hr "></div>
                </div>
              </div>
              <div class="input-div row">
                <div class="col-md-12 font-weight-bold">Product</div>
              </div> -->
              <div class="input-div row">
                <div class="col-md-12 col-12  ">
                  <label class="mb-0 font-weight-bold small ">Select your church membership size <span style="color: red"> *</span> </label>
                  <Dropdown @blur="invalidResponse" v-model="selectedMemberPlan" @change="memberSizePlan(selectedMemberPlan)" class="w-100 border font-weight-normal input-color" :options="memberSize"  optionLabel="name" placeholder="" />
                </div>
                <!-- <div class="col-md-12 col-12 mt-3">
                  <label class="mb-0 font-weight-bold small">Select an SMS bundle type </label>
                  <Dropdown v-model="selectedBundle" class="w-100 font-weight-normal border input-color" @change="smsBundleType(selectedBundle)"  :options="smsBundle"  optionLabel="name" placeholder="" />
                </div> -->
              </div>
             <!-- <div class="input-div row">
                <div class="col-12">
                  <label class="mb-0 font-weight-bold small">Do you need a church website <span style="color: red"> *</span> </label>
                  <div class="row">
                    <div class="col-md-6 small"><Checkbox id="binary" @change="checkValueYes(selectedCheckedYes)" v-model="selectedCheckedYes" :binary="true" class="mr-2" /><label for=""></label>Yes</div>
                    <div class="col-md-6 small"><Checkbox id="binary" @change="checkValueNo(selectedCheckedNo)" v-model="selectedCheckedNo" :binary="true" class="mr-2" /><label for=""></label>No</div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="input-div row" v-if="!selectedCheckedNo">
                <div class="col-md-12">
                  <label class="mb-0 font-weight-bold small">Select the website package you need <span style="color: red"> *</span> </label>
                  <Dropdown v-model="selectedWebPackage" @change="websitePackagePlan(selectedWebPackage)" class="w-100 border font-weight-normal input-color" :options="websitePackage"  optionLabel="name" placeholder="" />
                </div>
              </div> -->
              <!-- <div class="input-div row">
                <div class="col-12">
                  <label class="mb-0 font-weight-bold small">Do you need a church mobile app <span style="color: red"> *</span> </label>
                  <div class="row">
                    <div class="col-md-6 small"><Checkbox  id="binary" @change="itemValueYes(selectedCheckYes)" v-model="selectedCheckYes" :binary="true" class="mr-2" /><label for=""></label>Yes</div>
                    <div class="col-md-6 small"><Checkbox id="binary" @change="itemValueNo(selectedCheckNo)" v-model="selectedCheckNo" :binary="true" class="mr-2" /><label class="" for=""></label>No</div>
                  </div>
                </div>
              </div> -->
              
                <!-- <div class="input-div row"  :class="{'hideMobile' : addMobilePac, 'showMobile' : !addMobilePac }">
                
                  <div class="col-md-12">
                    <label class="mb-0 font-weight-bold small ">Select the mobile app package you need <span style="color: red"> *</span> </label>
                    <Dropdown v-model="selectedMobilePackage" @change="mobilePackagePlan(selectedMobilePackage)" class="w-100 border font-weight-normal input-color" :options="mobilePackage"  optionLabel="name" placeholder="" />
                  </div>
                </div> -->
             
               
               <!-- <div class="input-div row">
                <div class="col-md-12 d-flex ">
                  <div>
                    <Checkbox id="binary" @change="onlineGivChecked(onlineCheck)" v-model="onlineCheck" :binary="true" class="mr-2" />
                  </div>
                  <div>
                    <label for="" class="font-weight-bold small">I need online giving (free)</label>
                  </div>
                </div>
              </div> -->
               <div class="input-div my-4 row">
                  <div class="col-md-12">
                    <div class="col-md-12 input-color2 py-2 d-flex    ">
                        <div class="col-md-6  font-weight-bold "> Total Monthly Payment </div>
                
                        <div class=" text-right col-md-6  font-weight-bold">
                          NGN{{Math.round(mobilePerMonth + smsPerMonth + memberPerMonth).toLocaleString()}}.00
                          <div class="d-flex justify-content-end">
                               <hr class=" horizontal-rule" />
                          </div>
                         
                        </div>
                    </div>
                  </div>
              </div>

              <div class="row input-div d-block d-md-none">
                <div class="col-md-9 " :class="{'hidePlan' : !basicPlan, 'showPlan' : basicPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Basic Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Online giving</li>
                      <li>500 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9" :class="{'hidePlan' : !standardPlan, 'showPlan' : standardPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Standard Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Free Android and iOS mobile App</li>
                      <li>Online giving</li>
                      <li class="py-2">500 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9" :class="{'hidePlan' : !premiumPlan, 'showPlan' : premiumPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Premium Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Free Android and iOS mobile App</li>
                      <li>Online giving</li>
                      <li class="py-2">1,000 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9" :class="{'hidePlan' : !platinumPlan, 'showPlan' : platinumPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Platinum Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Free Android and iOS mobile App</li>
                      <li>Online giving</li>
                      <li class="py-2">1,500 units of SMS</li>
                    </ul>
                  </div>
                </div>
              </div>
              

              

              <!-- <div class="input-div cstm-select w-100" id="myInput">
                <label class="mb-0"
                  >What's the membership size of your association?</label>
                  <SelectElem :typ="'churchsize'" name="churchSize" :options="['--Select size range--', 'Between 1 - 100', 'Between 100 - 1000', 'Between 1000 - 100000']" value="--Select size range--" @input="itemSelected"/>
                <Dropdown
                  v-model="userDetails.churchSize"
                  :options="['1 - 100', '101 - 200', '201 - 500', '501 - 2000', '2001 - 10,000']"
                  style="width: 100%"
                  placeholder="Select size range"
                />
              </div> -->

              
              <div class="input-div row"> 
                <div class="col-md-12">
                  <button
                    type="submit"
                    class="submit-btn sign-in-btn default-btn font-weight-700 codeModal"
                    :class="{ disabled: !disableNext, 'btn-loading': loadingSave }"
                    :disabled="!disableNext"
                    
                  >
                    <i class="fas fa-circle-notch fa-spin codeModal" v-if="loadingSave"></i>
                    <span class="codeModal">Submit</span>
                    <span class="codeModal"></span>
                  </button>
                </div>
                  
              </div>
             
            </form>
            
          </div>
          <!-- <SelectElem name="test" :options="[1, 2, 3]" value="2" v-if="false"/> -->
        </div>
         <div
          class="col-sm-12 col-md-6 "
          id="onboarding-visuals"
          :class="{ 'swap-box2': toggle }"
          ref="box2"
        >
          <div class="step">
            <!-- <h3 class="font-weight-bold">STEP 1 OF 2</h3> -->
          </div>

          <div class="mt-4">
            <div>
              <div class="onboarding-image-con  ">
                <img src="../../assets/wema-faith/Alatfaithlogo.png" alt="Image" />
                <!-- <span class="reactive-text">{{ churchName }}</span> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 d-flex flex-wrap justify-content-center">
                <!-- <div class="col-md-12 font-weight-bold h1 text-center mt-4 " style="color: #9f157f;">ALAT FAITH</div> -->
                <div class="col-md-9 "  :class="{'hidePlan' : !basicPlan, 'showPlan' : basicPlan }">
                  <div class="col-md-12 text-cente font-weight-bold m-0  h5 py-2" style="border: 1px solid #900a39;">Basic Plan</div>
                  <div class="  col-md-12   " style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Online giving</li>
                      <li>500 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9" :class="{'hidePlan' : !standardPlan, 'showPlan' : standardPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Standard Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Free Android and iOS mobile App</li>
                      <li>Online giving</li>
                      <li class="py-2">500 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9" :class="{'hidePlan' : !premiumPlan, 'showPlan' : premiumPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Premium Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Free Android and iOS mobile App</li>
                      <li>Online giving</li>
                      <li class="py-2">1,000 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-9" :class="{'hidePlan' : !platinumPlan, 'showPlan' : platinumPlan }">
                  <div class="col-md-12 text-cente font-weight-bold border-bottom-0 m-0  h5 py-2 " style="border: 1px solid #900a39;">Platinum Plan</div>
                  <div class="  col-md-12" style="border: 1px solid #900a39;">
                    <ul>
                      <li class="py-2">Church Administration</li>
                      <li>Database Management</li>
                      <li class="py-2">Free Android and iOS mobile App</li>
                      <li>Online giving</li>
                      <li class="py-2">1,500 units of SMS</li>
                    </ul>
                  </div>
                </div>
                <div class=" col-md-9 ml-2 mt-2 " v-if="!selectedMemberPlan.price"><p>A range of technology and financial solutions for Churches and other faith-based organizations.</p></div>
            </div>
            <div class="col-md-12 d-flex justify-content-center mt-3 flex-wrap" v-if="!selectedMemberPlan.price">
                <div class="font-weight-bold h6 col-md-9 ml-2  ">Join 11,200 using ALAT Faith solution</div>
                <div class="col-md-9 d-flex flex-wrap justify-content-center justify-content-md-start ml-2 " style="gap: 20px;">
                    <span class="logo"><img src="../../assets/wema-faith/download-1.png" alt=""></span>
                    <span class="logo"><img src="../../assets/wema-faith/winners-logo.png" alt=""></span>
                    <span class="logo"><img src="../../assets/wema-faith/assemblies-of-god-logo.png" alt=""></span>
                    <span class="logo"><img src="../../assets/wema-faith/cgmi1-min-Mask.png" alt=""></span>
                    <span class="logo"><img src="../../assets/wema-faith/cornerstone-bible-church-logo1-1024x1024-1.png" alt=""></span>
                    <span class="logo"><img src="../../assets/wema-faith/insight_bible-church_Mask-2.png" alt=""></span>
                    <span class="logo"><img src="../../assets/wema-faith/Lbbwk7FK_400x400.png" alt=""></span>
                </div>
            </div>
          </div>
          
          
        </div>
       
       
      </div>
    </div>
    
    <!-- <select>
      <option v-for="country in countryCodes" :key="country.id">{{ countryCodes }}</option>
    </select> -->
    
  </div>
</template>

<script>
import axios from "@/gateway/backendapi";
import finish from '../../services/progressbar/progress'
import Dropdown from "primevue/dropdown";
import router from '../../router/index';
import Toast from 'primevue/toast'
import axio from  'axios'
export default {
  components: { Dropdown, Toast },
  // beforeRouteLeave() {
  //   const userEmail = localStorage.getItem("email");
  //   if (userEmail) localStorage.removeItem("email");
  // },

  // beforeRouteEnter() {
    // if (localStorage.getItem("token")) router.push("/next")
    // return next(false);
  // },

  data() {
    return {
      toggle: false,
      loadingSave: false,
      checking: false,
      showBtnText: "Show",
      password: '',
      passwordType: 'password',
      passwordIsVissible: false,
      zipCode: "",
      basicPlan: false,
      standardPlan: false,
      premiumPlan: false,
      platinumPlan: false,
      step1Completed: true,
      selectedBundle: {},
      onboardingObj: {},
      wemaDetail: {},
      maskChurchName: "",
      maskPhoneNumber: "+234",
      smsPerMonth: 0,
      memberPerMonth: 0,
      mobilePerMonth: 0,
      errorMessage: "",
      email: '',
      maxEmail: '',
      totalMonthlyPaymnent: 0,
      selectedCheckNo: '',
      churchName: '',
      // selectedCheckedYes: '',
      // selectedCheckedNo: '',
      selectedCheckYes: '',
      onlineCheck: '',
      selectedMemberPlan: {},
      // selectedWebPackage: {},
      selectedMobilePackage: {},
      nigerianBanks: [],
      accountNumber: '',
      phoneNumber: "+234",
      memberSize:[
        {name: "Basic plan (0-200 members(#3,000))", price: 36000, id: 2},
        {name: "Standard plan (200-500 members(#7,000))", price: 84000, id: 3 },
        {name: "Premium plan (500-2000 members(#15,000))", price: 180000, id: 5 },
        {name: "Platinum plan  (2000 -10000 members(#21,000))", price: 252000, id: 7 }
      ],
      smsBundle:[
        {name: "500unit (#1,000)", price: 12000 },
        {name: "1,500unit (#3,000)", price: 36000 },
        {name: "2,500unit (#5,000)", price: 60000 },
        {name: "5,000unit (#10,000)", price: 120000 },            
      ],
      // websitePackage:[
      //   {name: "Basic Website(#70,000)", price: 70000},
      //   {name: "Standard Website(#130,000)",price: 130000 },
      //   {name: "Premium Website(#300,000)", price: 300000 }
      // ],
      mobilePackage:[
        {name: "Android (#7,000)", price: 84000},
        {name: "IOS (#8,000)", price: 96000},
        {name: "Android & IOS(#12,000)", price: 144000}
      ],
      userDetails: {
        subscriptionPlanID: 1,
        countryId: 89,
        password: "password",
      },

      myValue: '',
      myOptions: ['op1', 'op2', 'op3'],

      selectedCountry: {
      
      },
      countries: [{country: "Zambia", phoneCode: "234"}, {country: "Nigeria", phoneCode: "234"}, {country: "Congo", phoneCode: "235"}],
      loading: false,
      showCode: false,
      codeUrl: {},
      searchText: "",
      isValid: true,
      disableNext: false
    };
  },
  methods: {
    onInput(phone, phoneObject, input) {
      if (phoneObject?.formatted) {
        this.phoneNumber = phoneObject.formatted;

        // this.selectedCountry = this.countries.find(
        //   (i) => i.phoneCode == phoneObject.countryCallingCode
        // );
      }
    },

    showPassword(e) {
      e.preventDefault();
      if (!this.password) return false;
      this.passwordType = this.passwordIsVissible ? "password" : "text";
      this.passwordIsVissible = !this.passwordIsVissible;
      this.showBtnText = this.passwordIsVissible ? "Hide" : "Show";
    },
    myChangeEvent(val){
      console.log(val);
    },
    // onlineGivChecked(item){
    //   this.onlineCheck = item
    // },

    memberSizePlan(item){
      console.log(item.price,'😁😁😀😀22');
      this.memberPerMonth = item.price/12  
      if(item.price === 36000){
          this.basicPlan = true
          this.standardPlan = false
          this.premiumPlan = false
          this.platinumPlan = false

      }else if(item.price === 84000){
          this.standardPlan = true
          this.basicPlan = false
          this.premiumPlan = false
          this.platinumPlan = false

      }else if (item.price === 180000){
          this.premiumPlan = true
           this.basicPlan = false
          this.platinumPlan = false
           this.standardPlan = false

      }else if (item.price === 252000){
          this.platinumPlan = true
           this.premiumPlan = false
           this.basicPlan = false
           this.standardPlan = false
      }else{
        return item
      }
    },

    smsBundleType(item){
       this.smsPerMonth = item.price/12
    },

    mobilePackagePlan(item){
        console.log(item.price,'😁😁😀😀22');
         this.mobilePerMonth = item.price/12
    },
    // websitePackagePlan(item){
    //     console.log(item.price,'😁😁😀😀22');
    //   if(item.price == 70000 ){
    //     this.totalMonthlyPaymnent.push(item.price)
    //   }else if(item.price == 130000 ){
    //     this.totalMonthlyPaymnent.push(item.price)
    //   }else if(item.price == 300000){
    //      this.totalMonthlyPaymnent.push(item.price)
    //   }else{
    //     return item.price
        
    //   }
    // },


    itemValueNo(item){
      this.addMobilePac = true
      this.selectedCheckNo = item
      this.mobilePerMonth = 0
      if(this.selectedCheckNo == true){
       this.selectedCheckYes = false
       
       this.selectedMobilePackage = false
      }else{
        this.selectedCheckNo;
      }
    },
    itemValueYes(item){
      this.addMobilePac = false
      this.selectedCheckYes = item
      if(this.selectedCheckYes == true){
         this.selectedCheckNo = false
         
      }else{
        this.selectedCheckYes;
      }
    },
    // checkValueYes(item){
    //   this.selectedCheckedYes = item
    //   if(this.selectedCheckedYes == true){
    //      this.selectedCheckedNo = false
    //   }else{
    //     this.selectedCheckedYes;
    //   }
    // },
    // checkValueNo(item){
    //   this.selectedCheckedNo = item
    //   if(this.selectedCheckedNo  == true){
    //      this.selectedCheckedYes = false
    //   }else{
    //     this.selectedCheckedNo;
    //   }
    // },
    

    async resolveCustomerDetail () {

      console.log(this.accountNumber, "account")
            this.loading = true
            try {
                let header = { headers: { Authorization: `Bearer ${process.env.VUE_APP_PAYSTACK_SECRET_KEY}` }}
                console.log(header, "header");

                // let { data } = await axio.get(`https://api.paystack.co/bank/resolve?account_number=${this.accountNumber}&bank_code=035`, header)
                // console.log(data)
                // accountName.value = data.data.account_name
                // accNameRef.value.focus()
                // disabled.value = false

                // loading.value = false

                // toast.add({severity:'success', summary: 'Account Check Successful', detail:'The account check was successful', life: 4000});

            }
            catch (error) {
                finish()
                console.log(error)
                // if (error.toString().includes('422') || error.toString().includes('400')) {
                //     console.log('didnt verify')
                //     const gateway = gateways.value.find(i => i.name.toLowerCase().includes('paystack'))
                //     if (gateway) {
                //         paymentGateWaysDb.value = gateways.value.filter(i => gateway.name !== i.name)
                //     }   else {
                //         console.log('already removed')
                //     }
                    
                // }   else {
                //     // if (!accountNumber.value || accountNumber.value === "") {
                //     //     toast.add({severity:'warn', summary: 'No account number found', detail:'Please enter your account number', life: 4000});
                //     // }   else {
                //     //     toast.add({severity:'error', summary: 'Account Check Error', detail:'Please check your banks details again', life: 4000});
                //     // }
                // }
                this.loading = false

                
            }
            
            try {
                // let header = { headers: { Authorization: `Bearer ${process.env.VUE_APP_PAYSTACK_SECRET_KEY}` }}
                // console.log(header, "header");
                const respons  = await axios.get(`/VerifyWemaAccount?accountNumber=${this.accountNumber}`)
                this.churchName = respons.data.response ? respons.data.response.name : ""
                this.email = respons.data.response ? respons.data.response.emailAddress : ""
                this.phoneNumber = respons.data.response ? respons.data.response.phoneNumber : ""

                console.log(this.phoneNumber, "this phonenumber");

                this.maxEmail = this.email.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, "$1***@$2")
                this.maskPhoneNumber = this.phoneNumber.slice(0, 6) + this.phoneNumber.slice(2).replace(/.(?=...)/g, '*')
                this.maskChurchName = this.churchName.slice(0, 10) + this.churchName.slice(1).replace(/.(?=...)/g, '*')
                this.checking = true

                // this.disabled = false

                // this.loading = false

                // let { data } = await axio.post(`https://api.ravepay.co/flwv3-pug/getpaidx/api/resolve_account`, {
                //     recipientaccount: this.accountNumber,
                //     destbankcode: '035',
                //     PBFPubKey: "FLWPUBK-5445dc010a540955d37897b4265dc6b2-X"
                // })
                // console.log(data)
                // this.churchName = data.data.data.accountname
                this.disabled = false

                this.loading = false

                   if (respons.data.message.includes('getting')) {
                    this.$toast.add({
                    severity:'warn', 
                    summary: 'Unable to verify', 
                    detail: respons.data.message,
                    life: 8000
                });
                }else if(respons.data.message.includes('limit')){
                    this.$toast.add({
                    severity:'warn', 
                    summary: 'Rate limit is  exceeded', 
                    detail: respons.data.message,
                    life: 8000
                    });
                }else if(respons.data.message.toLowerCase().includes('found')) {
                   this.$toast.add({
                    severity:'warn', 
                    summary: 'Unable to verify', 
                    detail: respons.data.message, 
                    life: 8000
                });
                }else{
                    this.$toast.add({
                    severity:'success', 
                    summary: 'Account Check Successful', 
                    detail:'The account check was successful', 
                    life: 8000
                });
                }

            }
            catch (error) {
                finish()
                console.log(error)

                this.loading = false
                    if (!this.accountNumber || this.accountNumber === "") {
                        this.$toast.add({severity:'warn', summary: 'No account number found', detail:'Please enter your account number', life: 4000});
                    }   else {
                        this.$toast.add({severity:'error', summary: 'Account Check Error', detail:'Please check your banks details again', life: 4000});
                    }
                // }

                
            }
    },
    
    mySelectEvent({id, text}){
      console.log({id, text})
    },

    // saveForm() {

      saveForm() {
      this.loadingSave = true;
      let obj = {
        churchName: this.churchName,
        email: this.email,
        phoneNumber: this.phoneNumber,
        bankAccount: this.accountNumber,
        password: this.password,
        bankCode: "035",
        bankName: "Wema bank",
        countryID: this.selectedCountry.id,
        subscriptionPlanID: this.selectedMemberPlan.id,
        // churchSize: ,
        // memberPerMonth: this.memberPerMonth,
        // totalMonthlyPaymnent: this.memberPerMonth,
        amount: this.memberPerMonth,
        referrer: "WEMA"
      }
      // this.$router.push("/onetimepassword");
      console.log(obj, '😂😃❤❤🙌💕ww')
      this.showError = false;
      axios
        .post("/InitialSignUpV2", obj)
        // .post("/InitialSignUpV2", obj)
        .then((res) => {
          this.loadingSave = false;
          // this.onboardingObj = res.data
          // console.log(onboardingObj, "jjjhjjhj");
          console.log(res, "register response");
          this.$store.dispatch("setUserEmail", this.email);
          this.$store.dispatch("onboardingDataObject", res.data);
          localStorage.setItem("onboardingData", res.data);
          localStorage.setItem("email", this.email);
          this.$router.push('/onetimepassword');
        })
        .catch((err) => {
          /*eslint no-undef: "warn"*/
          NProgress.done();
          this.loadingSave = false;
          console.log(err.response);
          localStorage.setItem("email", this.email)
          if (err.response && err.response.status === 400) {
            if (err.response.data === false) {
              // this.$router.push("/onetimepassword")
              return false;
            }

            
            const { message } = err.response.data;
            if (message.includes("Sequence contains more than one element")) {
              this.errorMessage = "There seems to be a problem with this account, please";
              this.showResetLink = false;
            } else {
              this.errorMessage = message ? message : "An error occurred";
            }
            this.showError = true;
          } else {
            this.errorMessage = "An error occurred, ensure you are connected to the internet";
          }

        });
    },
      // if (!this.userDetails.email) return false;
      // this.userDetails.phoneNumber = this.userDetails.phoneNumber.includes("+")
      //   ? this.userDetails.phoneNumber
      //   : `+${this.selectedCountry.phoneCode}${this.userDetails.phoneNumber}`;
      //   console.log(this.selectedCountry, "country");
      //   this.userDetails.countryId = this.selectedCountry.id;
      // console.log(this.userDetails, "userDetails");
      
      // this.disableNext = true;
      // axios
      //   .post("/api/onboarding", this.userDetails)
      //   .then((res) => {
      //     this.loading = true;
      //     console.log(res, "onboarding response");
      //     if (!res.data.token) {
      //       const preToken = localStorage.getItem("pretoken");
      //       localStorage.setItem("token", preToken);
      //       localStorage.removeItem("pretoken");
      //     } else {
      //       localStorage.setItem("token", res.data.token);
      //       localStorage.setItem('roles', JSON.stringify(["Admin"]))
      //     }
      //     this.loading = false;
          // router.push("/tenant");
        // })
        // .catch((err) => {
          /*eslint no-undef: "warn"*/
        //   NProgress.done();
        //   this.loading = false;
        //   console.log(err.response);
        // });

      // this.$store.dispatch("setOnboardingData", this.userDetails);
      // this.$router.push("/onboarding/step2");
    // },
    toggleCode () {
      this.showCode = !this.showCode
      console.log(this.showCode)
    },
    tobby (){
      console.log("Its working")
      this.showCode = !this.showCode
    },
    selectCode (country) {
      console.log(country)
      this.selectedCountry = country
      this.showCode = false
    },
    hideModal (e) {
    console.log(this.showCode)
    if (!e.target.classList.contains("codeModal")){
      this.showCode = false
    }
  },
  invalidResponse () {
      if (!this.phoneNumber ) {
        // this.isValid = false
        this.disableNext = false
        
      } else {
        // this.isValid = true
        this.disableNext = true
      }
    },

  },

  computed: {

    // totalPricePerMonth() {
      // let total = 0;
      // for (let item in this.totalMonthlyPaymnent) {
      //   total = total + (this.totalMonthlyPaymnent[item] / 12 )

      // }
      //  return total;
      
    //   return this.totalMonthlyPaymnent.reduce((acc, item) => {

    // return acc + item / 12;

  // }, 0);
    // },

    // churchName() {
    //   if (!this.userDetails.churchName) return "";
    //   return this.userDetails.churchName.length < 21
    //     ? this.userDetails.churchName
    //     : this.userDetails.churchName.slice(0, 20) + "...";
    // },
    valid () {
      // let regex  = /^\\(?([0-9]{3})\\)?[-.\\s]?([0-9]{3})[-.\\s]?([0-9]{4})$/
      // let regex  = /[0-9]{11}/
      let regex  = /((^090)([23589]))|((^070)([1-9]))|((^080)([2-9]))|((^081)([0-9]))(\d{7})/
      return regex.test(this.phoneNumber)
    },

    countryCodes() {
      let codeFlag = []
      // if (this.searchText ===  "") {
      codeFlag = this.countries.map(i => {
        return {
          phoneCode: i.phoneCode,
          flagUrl: i.flagUrl,
          id: i.id,
          name: i.name,
          currency: i.currency
        }        
      })

      if (this.searchText)  return codeFlag.filter(i => i.phoneCode && i.phoneCode.includes(this.searchText.toLowerCase()) || i.phoneCode && i.name.toLowerCase().includes(this.searchText.toLowerCase()))
      
      return codeFlag
        
    },
    
  },

  // beforeCreate() {
  //   if (!localStorage.getItem("email")) router.push("/");
  // },
 
  created() {
    this.userDetails.email = localStorage.getItem("email");
    axios.get("/api/GetAllCountries").then((res) => {
      this.countries = res.data;
      console.log(res)
      this.selectedCountry = res.data.find(i => i.phoneCode &&  i.phoneCode.includes("234"))
        console.log(this.selectedCountry)
        console.log(this.countries)
    });

    // axios.get("VerifyWemaAccount?accountNumber=7821042572").then((res) =>{
    //   console.log(res, "response data");
    // })
    // .catch(err =>{
    //   console.log(err);
    // })

    // axios.get("/api/Financials/GetBanks")
    //             .then(res => {
    //             console.log(res, "88😆😅🤣😂😂😂")
    //             this.nigerianBanks = res.data
    //             })
    //             .catch(err => {

    //                 console.log(err)
    //             })

  },
};
</script>

<style scoped>
.logo {
    width: 35px;
}
.show-password {
  float: right;
}
.show-password-link {
  text-decoration: none;
  color: #900a39;
  font-weight: bold;
}

.password-help {
  margin-bottom: 24px;
  font-size: 14px;
  color: #718fa2;
  font-weight: lighter;
}

.horizontal-rule {
  border-radius: 5px;
  margin: 0.125rem 0;
  background: #900a39;
  width: 26%;
  height: 3px;
}

.hidePlan{
  height: 0 !important;
  width: 0% !important;
  overflow: hidden !important;
  transition: all 0.5s ease-in-out;
}

.showPlan{
  height: 15rem !important;
  width: 100% !important ;
  overflow: hidden !important;
  transition: all 0.5s ease-in-out;
}

.logo img {
    width: 100%;
}
.top-most {
  height: 100vh;
}

#onboarding {
  display: flex;
  height: 100vh;
}
.input-color{
  background: rgba(246, 235, 244, 0.25);
}
.input-color2{
  background: rgba(245, 167, 223, 0.25);
  /* opacity: 1; */
}

#onboarding-visuals {
  width: 45%;
  /* background: #4aa858; */
  height: 100;
  background-image: -webkit-linear-gradient(top, #afafaf 0%, #fdfffe 100%);
  transition: all 0.7s ease-in-out;
}

#onboarding-form {
  width: 55%;
  display: flex;
  padding: 10px;
  transition: all 0.7s ease-in-out;
}

.swap-box1 {
  transform: translateX(80%);
}

.swap-box2 {
  transform: translateX(-127%);
}

.sub-title {
  font-size: 20px;
  font-weight: lighter;
  color: #718fa2;
}

.onboarding-form-container {
  max-width: 650px;
  width: 100%;
  margin: auto;
}

.input-div {
  margin: 15px 0;
}

.input {
  font-family: Averta, sans-serif;
  color: #1c252c;
  font-weight: normal;
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 10px 6px;
  min-height: 40px;
  /* -webkit-appearance: button; */
  /* appearance: none; */
  outline: none;
  vertical-align: middle;
  transition: border 0.1s linear;
  /* border: 1px solid #b2c2cd; */
  margin: 4px 0;
}

option {
  color: red;
}

.input::placeholder {
  font-style: italic;
  color: #b2c2cd;
  letter-spacing: 0px;
}

.submit-btn {
background: #900a39;
  /* background: #136acd; */
  outline: none;
}

.disabled {
  /* background: #4aa858; */
  background: #fff9fb;
  /* background: rgb(141, 165, 238); */
}

.submit-btn:hover {
  cursor: pointer;
}

.sign-in-btn {
  color: #fff;
  border: 1px solid transparent;
  /* margin-top: 5px; */
  width: 100%;
  /* padding: 8px 10px; */
  box-sizing: border-box;
  text-align: center;
  min-width: 100px;
  border-radius: 500px;
  vertical-align: middle;
  text-decoration: none;
  appearance: none;
  font-weight: 400;
  font-size: 16px;
}

.input:focus {
  box-shadow: 0 0 0 3px rgba(19, 106, 205, 0.2);
}

.name-input {
  display: flex;
  justify-content: space-between;
}

.name-input input {
  width: 48%;
}

.phone-input {
  display: flex;
  justify-content: space-between;
}

.phone-input .zip-code {
  width: 12%;
  min-width: 77px;
  max-width: 78px;
  color: #3e3e42;
}

.step {
  text-align: center;
  /* color: #fff; */
  color: rgb(55, 55, 55);
  margin: 30px 0;
  font-weight: bolder;
}

.onboarding-image-con {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-left: auto;
  position: relative;
}

.onboarding-image-con img {
  width: 30%;
  height: 30%;
}

.reactive-text {
  position: absolute;
  top: 8%;
  left: 24%;
  width: 70%;
  font-size: 23px;
  font-weight: 600;
  color: #4d6575;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phone-input .phone-num {
  margin-left: 2px;
}

/* Codes */
.codes {
  border: 1px solid #b2c2cd;
  padding: 4px;
  margin: 0;
  border-radius: 4px;
  width: 77px;
  position: absolute;
  background: #fff;
  max-height: 300px;
  overflow: scroll;
  display: none;
}

.code:hover {
  cursor: pointer;
  background: #b2c2cd85;
  padding: 4px;
}

.input:after {
  content: "\25bc" !important;
  color: #aaa;
  font-size: 12px;
  position: absolute;
  right: 8px;
  top: 10px;
}

.show {
  display: block;
}

span .select2-selection--single {
  padding: 0px 10px !important;
  height: 40px !important;
  margin-top: 4px !important;
  display: flex !important;
  align-items: center !important;
  border: 1px solid #b2c2cd;
}
.select2-container .select2-choice {
    padding: 5px 10px;
    height: 100px;
    width: 132px; 
    font-size: 1.2em;  
}

/* #size {
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
 
} */

/* drop arrow */
/* #size:after  {
  content: "\25bc" !important;
  color: #aaa;
  font-size: 12px;
  position: absolute;
  right: 8px;
  top: 10px;
}

#size {
  appearance: none !important;
} */

#myInput {
  display: flex;
  flex-direction: column;
}

.flagCode {
    width: 330px;
    max-height: 19em;
    overflow-y: scroll;
    overflow-x: hidden;
    box-shadow: -3px 3px 15px #797e8159;
    position: absolute;
    top: 54%;
    /* left: 48px; */
    background: white;
    
    /* display: block; */

}
/* .flagCode > div:first-of-type{ */
  /* border: 2px solid green; */
  /* width: 35em;      
} */
.flagCode div:hover {
  background: rgb(238, 238, 238)
}

@media screen and (max-width: 800px) {
  #onboarding {
    display: block !important;
  }

  #onboarding-form {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  
  


  #onboarding-visuals {
    display: none !important;
  }

  .flagCode {
    position: absolute;
    top: 30%;
  }
}

@media  screen and (max-width: 800) {
  
}

@media screen and (min-width: 480) {
  .main-title {
    font-size: 33px;
  }
}

@media (max-width: 504px) {
  .flagCode {
    margin-top: 11%;
  }
}
@media (max-width: 341px) {
  .flagCode {
    margin-top: 23%;
  }
}

div.country-code {
  height: 40.9px;
  background: transparent
}

 input.codeInput {
  width: 93%;
  margin-left: 12px;
  margin-top: 5px;
}

.hide-code {
  /* display: none */
  height: 0;
  overflow: hidden;
  /* transition: all 0.4s ease-in-out */
}
</style>